import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

type GetSaltoSpaceUserRequest = {
  email: string
}

export type SaltoSpaceUser = {
  doorIds: string[]
  permissionGroupIds: string[]
  accessLevelIds: string[]
  authorizationCodes?: string[]
  userExpiration: string | null
}

export const getSaltoSpaceUserQueryKey = (data: GetSaltoSpaceUserRequest) => [
  'useGetSaltoSpaceUser',
  data,
]

const getSaltoSpaceUser = async (data: GetSaltoSpaceUserRequest) => {
  const response = await authAPI.get<SaltoSpaceUser>('/salto-space/user', {
    params: { email: data.email },
  })
  return response.data
}

export const useGetSaltoSpaceUser = (data: GetSaltoSpaceUserRequest, enabled = true) =>
  useQuery({
    enabled: enabled && Boolean(data.email),
    queryFn: () => getSaltoSpaceUser(data),
    queryKey: getSaltoSpaceUserQueryKey(data),
  })
